import db from './indexDB'

export default {
    /**
     * Fetch User from IndexDB
     * @return {Object} -- User
     */
    async getUser() {
        return await db.users.toCollection().first();
    },
    /**
     * Add user to IndexDB
     * @user {Object} -- User
     */
    async addUser(user) {
        await db.users.put({
            FullName: user.FullName,
            IsGlobalAdmin: user.IsGlobalAdmin,
            PersonnelID: user.PersonnelID,
            PrimaryPlantID: user.PrimaryPlantID,
            AdminFarmTypeIDs: user.AdminFarmTypeIDs
        });
    },
    /**
     * Clear User and Access Rights from the database
     */
    async clearUser() {
        await db.users.clear();
    },

    /**
     * Fetch User Access from IndexDB
     * @return {Object[]} -- Array of Access Rights
     */
    async getAccess() {
        return await db.userAccess.toArray();
    },
    /**
     * Add access rights to IndexDB
     * @user {Object} -- User
     */
    async addAccess(access) {
        await db.userAccess.put({
            Access: access.Access,
            PlantID: access.PlantID
        })
    },
    /**
     * Clear Access Rights from the database
     */
    async clearAccess() {
        await db.userAccess.clear();
    },
}